<template>
  <div class="header-container">
    <div class="header flex-row-center-center" :class="[hasBorder?'':'no-border']">
      <div v-show="leftShow" class="left" @click="go">
        <i class="iconfont">&#xe86b;</i>
      </div>
      <div class="title">{{ title }}</div>
    </div>
    <div class="pad" />
  </div>
</template>

<script>
export default {
  name: 'HeaderTop',
  props: {
    title: {
      type: String,
      default: ''
    },
    leftShow: {
      type: Boolean,
      default: true
    },
    hasBorder: {
      type: Boolean,
      default: true
    },
    path: {
      type: String,
      default: ''
    }
  },
  methods: {
    go() {
      if (this.path) {
        this.$router.push(this.path)
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  z-index: 100;
  left: 0;
  right: 0;
  top: 0;
  height: 35px;
  background: #ededed;
  border-bottom: 1px solid #eee;

  .left {
    position: absolute;
    left: 15px;

    i {
      font-size: 16px;
      color: #000;
    }
  }

  .title {
    color: #000;
    font-size: 14px;
  }

  &.no-border {
    border-bottom: none;
  }
}

.pad {
  padding-bottom: 36px;
}
</style>
